import React, { useEffect, useState } from "react";
import SidebarMenu from "./SidebarMenu/SidebarMenu";
import Style from "./LayoutContainer.module.scss";
import SidebarMenuPeyk from "./SidebarMenuPeyk/SidebarMenuPeyk";

const LayoutContainer = (props) => {
  const [project, setProject] = useState(localStorage.getItem("Tab"));
  useEffect(() => {
    if (!localStorage.getItem("Tab")) {
      setProject("food");
      localStorage.setItem("Tab", "food");
    }
  }, []);
  const changeProje = (type) => {
    if (type === 1) {
      setProject("taxi");
      localStorage.setItem("Tab", "taxi");
    }
    if (type === 2) {
      setProject("buy");
      localStorage.setItem("Tab", "buy");
    }
    if (type === 3) {
      setProject("food");
      localStorage.setItem("Tab", "food");
    }
  };
  let content = null;

  if (project=== "taxi") {
    content = <p>تاکسی</p>;
  } else if (project=== "food") {
    content = (
      <>
        <div className={Style.sidebar}>
          <SidebarMenu/>
        </div>
        <div className={Style.childrens}>{props.children}</div>
      </>
    );
  } else if (project=== "buy") {
    content = (
      <>
        <div className={Style.sidebar}>
          <SidebarMenuPeyk/>
        </div>
        <div className={Style.childrens}>{props.children}</div>
      </>
    );
  }
  return (
    <div className={Style.componentHolder}>
      <div className={Style.centerHolder}>
        {content}
      </div>
    </div>
  );
};

export default LayoutContainer;
